import React, { useState, useEffect, Children } from 'react';
import { connect } from 'react-redux';
import { Card, Input, Col, Row, Button, Label } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import ReactTable from 'react-table';
import ReactQuill from 'react-quill';
import { Editor } from '../../../../../../../../Utils/Constants';
import CustomModal from '../../../../../../../Components/Modals/CustomModal';
import FetchSubmissionsChatsService from '../../../../../../../../Service/DashboardServices/ContentManagementServices/FetchSubmissionsChatsService';
import CommentIcon from '../../../../../../../../designUtils/ProjectDashboard/CommentIcon.svg';
import ViewIcon from '../../../../../../../../designUtils/ProjectDashboard/ViewIcon.svg';
import DownloadIcon from '../../../../../../../../designUtils/ProjectDashboard/DownloadIcon.svg';
import AssetsCommentsPopup from '../AssetAnnotations/AssetsCommentsPopup';
import LoadingOverlay from "react-loading-overlay";
import Loader from "react-loaders";
import AddSubmissionsChatService from '../../../../../../../../Service/DashboardServices/ContentManagementServices/AddSubmissionsChatService';
import { faDownload } from "@fortawesome/free-solid-svg-icons";
import SendAssetsApprovalPopup from './SendAssetsApprovalPopup';

function DocumentsSubmission(props) {
  const [documentSearchText, setDocumentSearchText] = useState('');
  const [selectedDocuments, setSelectedDocuments] = useState([]);
  const [selectAllDocuments, setSelectAllDocuments] = useState(false);
  const [sumbmissionNote, setSubmissionNote] = useState('');
  const [confrimationForSubmition, setConfrimationForSubmition] = useState(false);
  const [selectedFileObject, setSelectedFileObject] = useState({});
  const [loadScreen, setLoadScreen] = useState(false);
  const [noteList, setNoteList] = useState([]);
  const [isCommentsPopUpOPen, setIsCommentsPopUpOPen] = useState(false);
  const [demoImage, setDemoImage] = useState(false);
  const [filePath, setFilePath] = useState('');
  const [isAttachmentOpen, setIsAttachmentOpen] = useState(false);
  const [downloading, setdownloading] = useState(false);
  const [comment, setComment] = useState('');
  const [filteredDocuments, setFilteredDocuments] = useState([]);

  // Same filtering logic as GraphicsSubmission but for documents
  useEffect(() => {
     console.log(props.fileList)
         const filtered = getFilteredDocumentFiles(props.fileList, props.selectedASIN);
       setFilteredDocuments(filtered);
       }, [props.selectedASIN, props.fileList]);

  const getFilteredDocumentFiles = (fileList, selectedASIN) => {
    const documentExtensions = ['csv', 'docx', 'xlsx', 'xls', 'doc', 'xlsm', 'pdf'];

    return (fileList || []).filter(file => {
      const isDocument = file.actualFileName &&
        documentExtensions.includes(file.actualFileName.split('.').pop().toLowerCase());

      if (!isDocument) {
        return false;
      }

      const fileAsins = (typeof file.asinList === 'string' && file.asinList.trim() !== '')
        ? file.asinList.split(',').map(a => a.trim().toUpperCase()).filter(Boolean)
        : [];

      if (selectedASIN === "Unmapped Assets") {
        const isOthers = fileAsins.length === 0;
        return isOthers;
      }

      const normalizedSelectedASIN = selectedASIN ? selectedASIN.toUpperCase() : '';
      const isMatch = fileAsins.includes(normalizedSelectedASIN);
      return isMatch;
    });
  };

  const searchedDocuments = filteredDocuments.filter(file =>
    file.actualFileName.toLowerCase().includes(documentSearchText.toLowerCase()) ||
    String(file.id).includes(documentSearchText)
  );

  const handleDocumentCheckboxChange = (id) => {
    setSelectedDocuments(prev =>
      prev.includes(id) ? prev.filter(docId => docId !== id) : [...prev, id]
    );
  };
  const handleSelectAllDocuments = () => {
    const newSelectAll = !selectAllDocuments;
    setSelectAllDocuments(newSelectAll);
    if (newSelectAll) {
      const allDocumentIds = filteredDocuments.map(doc => doc.id);
      setSelectedDocuments(allDocumentIds);
    } else {
      setSelectedDocuments([]);
    }
  };

  const handleSubmissionSuccess = (res) => {
    props.setFileList(res.fileList.fileList);
    props.setSubmissionInnerCount(res.innerCountsOfSubmission);
    props.setSubmissionList(res.submissionList.submissionList);
    setSelectedDocuments([]);
    setSelectAllDocuments(false);
    setConfrimationForSubmition(false);

    if (res.fileList.asinAssetsCount) {
      if (props.selectedASIN === 'Unmapped Assets') {
        props.setUnmappedCount(res.fileList.asinAssetsCount.unmapped_count);
      } else {
        const updatedCount = res.fileList.asinAssetsCount.resultcnt[0];

        if (updatedCount) {
          props.setAsinCount((prevCounts) =>
            prevCounts.map((item) =>
              item.asinList === updatedCount.asinList ? updatedCount : item
            )
          );
        }
      }
    }

    setSubmissionNote('');
  };

  const submissionsChats = (file) => {
    let data = {
      assetId: file.id
    };
    setSelectedFileObject(file);
    setLoadScreen(true);
    FetchSubmissionsChatsService(props.token, data).then((res) => {
      console.log(res);
      setNoteList(res);
      setLoadScreen(false);
    });
    setIsCommentsPopUpOPen(true);
    showNote(file.fileName, file.filePath);
  };

  const showNote = (path, fullPath) => {
    console.log(path);
    const ext = path.split(".")[1];
    if (ext == "xlsx" || ext == "csv" || ext == "xls" || ext == "docx" || ext == "doc" || ext == 'xlsm') {
      setDemoImage(true);
    } else {
      setFilePath(fullPath);
      setDemoImage(false);
    }
  };

  const handleDownloadImage = async (url, fileObject) => {
    try {
      setdownloading(fileObject.id);
      const response = await fetch(url, {
        method: 'GET',
        referrerPolicy: 'no-referrer',
        cache: 'no-store',
      });

      if (!response.ok) throw new Error(`Network response was not ok for ${fileObject.id}`);

      const blob = await response.blob();
      const blobUrl = URL.createObjectURL(blob);

      const downloadLink = document.createElement('a');
      downloadLink.href = blobUrl;
      downloadLink.download = fileObject.actualFileName || 'downloaded_file';
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);

      URL.revokeObjectURL(blobUrl);
      setdownloading(false);
    } catch (error) {
      console.error('Failed to download files:', error);
      setdownloading(false);
    }
  };

  const addSubmissionsChats = () => {
    const data = {
      notes: comment,
      assetId: selectedFileObject.id,
    };

    AddSubmissionsChatService(props.token, data).then((res) => {
      if (res) {
        setNoteList(res.noteList);
        setComment('');
      }
    });
  };

  const handleQuillChange = (value) => {
    setSubmissionNote(value);
  };

  const columns = [
    {
      width: 50,
      accessor: "checkbox",
      Cell: (rowInfo) => (
        <input
          type="checkbox"
          value={rowInfo.original.id}
          checked={selectedDocuments.includes(rowInfo.original.id)}
          onChange={() => handleDocumentCheckboxChange(rowInfo.original.id)}
        />
      ),
    },
    {
      Header: "Name",
      accessor: "actualFileName",
      Cell: ({ value }) => (
        <p title={value} className="m-0 comment-paragraph">{value}</p>
      ),
    },
    {
      Header: "Action",
      accessor: "action",
      Cell: (rowInfo) => {
        const file = rowInfo.original;
        const fileExtension = file.actualFileName.split('.').pop().toLowerCase();
        const isPDF = fileExtension === 'pdf';

        return (
          <div className="d-flex justify-content-center align-items-center">
            <button
              onClick={() => submissionsChats(rowInfo.original)}
              className="btn"
            >
              <img
                className="comments-bg-color"
                height={20}
                width={20}
                title="Notes"
                src={CommentIcon}
              />
            </button>
            {isPDF && (
              <img
                src={ViewIcon}
                alt="Preview"
                height={20}
                width={20}
                style={{ cursor: 'pointer' }}
                title="Preview"
                onClick={() => {
                  setFilePath(file.filePath);
                  setSelectedFileObject(file);
                  setIsAttachmentOpen(true);
                }}
              />
            )}
            <img
              src={DownloadIcon}
              alt="Download"
              height={20}
              width={20}
              style={{ cursor: 'pointer', marginLeft: isPDF ? '10px' : '0px' }}
              title="Download"
              className={
                downloading && downloading === file.id
                  ? "button-img-background-download-inprogress"
                  : ""
              }
              onClick={() => {
                if (downloading !== file.id) {
                  setSelectedFileObject(file);
                  setdownloading(file.id);
                  handleDownloadImage(file.filePath, file);
                }
              }}
            />
          </div>
        );
      }
    }
  ];

  return (
    <>
      <Row>
        <Col md={6}>
          <Card className="card-of-problemarea p-3 mt-1 ml-3">
            <div className="d-flex align-items-center justify-content-between">
              <h6 className="mb-0 mr-3">
                <div className="d-flex align-items-center">
                  <input
                    type="checkbox"
                    id="selectAllDocs"
                    checked={selectAllDocuments}
                    onChange={handleSelectAllDocuments}
                  />
                  <label htmlFor="selectAllDocs" className="mb-0 ml-2">
                    <b>Select All</b>
                  </label>
                </div>
              </h6>
              <Input
                type="text"
                placeholder="Search Text"
                className="w-50"
                value={documentSearchText}
                onChange={(e) => setDocumentSearchText(e.target.value)}
              />
            </div>
            <ReactTable
              className="-fixed -highlight -striped mt-2"
              data={searchedDocuments}
              columns={columns}
              defaultPageSize={4}
              noDataText="No documents found..."
              getTheadProps={() => ({
                style: {
                  overflow: "hidden",
                  background: "#B1FA63",
                  color: "#243837",
                },
              })}
              getTrProps={() => ({
                style: {
                  height: "35px",
                },
              })}
            />
          </Card>
        </Col>
        <Col md={6} className="mt-4">
          <label><h6><b>Note:</b></h6></label>
          <ReactQuill
            theme={'snow'}
            value={sumbmissionNote}
            modules={Editor.modules}
            formats={Editor.formats}
            onChange={handleQuillChange}
            bounds={'.quill-prod'}
            placeholder='Add your comments here'
          />
        </Col>
        <Col md={12} className="mt-4 mb-2">
          <div className="d-flex justify-content-center">
            <Button
              className="btn-background-color mr-5"
              style={{ width: '300px' }}
              onClick={() => setConfrimationForSubmition(true)}
              disabled={selectedDocuments.length === 0}
            >
              Send Documents for Approval
            </Button>
          </div>
        </Col>
      </Row>

      <SendAssetsApprovalPopup
        isOpen={confrimationForSubmition}
        toggle={() => setConfrimationForSubmition(false)}
        mode="documents"
        selectedAssetIds={selectedDocuments}
        fileList={filteredDocuments}
        filterSubcategoryList={props.filterSubcategoryList}
        filterProductSubcategoryList={props.filterProductSubcategoryList}
        selectedProjectData={props.selectedProjectData}
        selectedSubCategories={props.selectedSubCategories}
        selectedASIN={props.selectedASIN}
        submissionNote={sumbmissionNote}
        submissionName={
          props.selectedASIN ? `Document_${props.selectedASIN}` : 'Other'
        }
        headerTitle="Send Documents for Approval"
        token={props.token}
        onSubmitSuccess={handleSubmissionSuccess}
      />

      <CustomModal
        isOpen={isCommentsPopUpOPen}
        toggle={() => setIsCommentsPopUpOPen(false)}
        size="xl"
        header={<p title={selectedFileObject.actualFileName} className="comment-paragraph-Project-asin-title">{selectedFileObject.actualFileName}</p>}
        className="curve-popup "
      >
        <LoadingOverlay
          active={loadScreen}
          styles={{
            overlay: (base) => ({
              ...base,
              background: '#f1f4f6',
              opacity: 1,
            }),
            content: (base) => ({
              ...base,
              color: '#000',
            }),
          }}
          spinner={<Loader active type="ball-pulse" />}
          text="Loading chat details..."
        >
          <AssetsCommentsPopup
            filePath={filePath}
            demoImage={demoImage}
            noteList={noteList}
            setNote={setComment}
            note={comment}
            action={false}
            selectedFileObject={selectedFileObject}
            addCMAssetChats={addSubmissionsChats}
          />
        </LoadingOverlay>
      </CustomModal>

      <CustomModal
        header={<> Attachment
          <FontAwesomeIcon
            className={`ml-3 ${downloading ? 'button-img-background-download-inprogress' : ''}`}
            style={{ cursor: 'pointer' }}
            icon={faDownload}
            onClick={() => handleDownloadImage(filePath, selectedFileObject)}
          />
        </>}
        isOpen={isAttachmentOpen}
        toggle={() => { setIsAttachmentOpen(!isAttachmentOpen); setdownloading(false) }}
        size={"lg"}
        className='curve-popup'
        footer={
          <>
            <Button
              color={"link"}
              onClick={() => setIsAttachmentOpen(!isAttachmentOpen)}
            >
              Cancel
            </Button>
          </>
        }
      >
        <Label>
          <div>
            <iframe
              src={filePath}
              title="File Display"
              width="100%"
              height="500"
            ></iframe>
          </div>
        </Label>
      </CustomModal>
    </>
  );
}

const mapStateToProps = (state) => ({
  token: state.loggedUser.token,
  storeOverview: state.accountOverview.store.storeOverview,
});

export default connect(mapStateToProps)(DocumentsSubmission);
